import React from "react";

const FACTORY =
  "https://images.unsplash.com/photo-1720036237193-ea82bdac7be0";

const STEPS = [
  {
    n: "01",
    t: "Upload",
    d: "Drop your STL/OBJ/STEP. We'll review wall thickness, supports & orientation within 24h.",
  },
  {
    n: "02",
    t: "Quote",
    d: "Transparent pricing — material, machine time, finishing & shipping itemized.",
  },
  {
    n: "03",
    t: "Print",
    d: "Approved jobs hit the queue. Live status updates while your part is on the bed.",
  },
  {
    n: "04",
    t: "Finish & Ship",
    d: "Sanding, vapor smoothing, paint or assembly. Out the door, anywhere worldwide.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-b border-[#2A2A2A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Steps */}
        <div>
          <p className="overline mb-6">// 03 — How it works</p>
          <h2
            className="font-display uppercase leading-[0.9] text-white mb-10"
            style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
            data-testid="process-headline"
          >
            From file<br />
            to <span className="text-[#FF5722]">finished</span> part.
          </h2>

          <div className="border-t border-[#2A2A2A]">
            {STEPS.map((s) => (
              <div
                key={s.n}
                className="grid grid-cols-12 gap-6 border-b border-[#2A2A2A] py-8 group hover:bg-[#0F0F0F] transition-colors"
                data-testid={`process-step-${s.n}`}
              >
                <div className="col-span-2 md:col-span-2">
                  <span className="font-display text-white/40 group-hover:text-[#FF5722] transition-colors text-3xl md:text-5xl leading-none">
                    {s.n}
                  </span>
                </div>
                <div className="col-span-10 md:col-span-3">
                  <h3 className="font-display uppercase text-white text-2xl md:text-3xl leading-none">
                    {s.t}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-7">
                  <p className="font-body text-white/70 max-w-md">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
